import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../contexts/store-provider';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';
import DefaultModal from '../../../shared-components/modal/default-modal';
import CorrectionRequestForm from '../forms/correction-request-form';
import toast from 'react-hot-toast';
import { formatMessage } from '../../../translations/format-message';
import {
  ICorrectionFileList,
  ICorrectionRequest,
} from '../../../models/forms/ICorrectionControl';

interface ICorrectionRequestFormModalProps {
  id: string;
  modalClosed: () => void;
  ProductId: number;
  ProductName: string;
  ProcessId: number;
  TrayId: number;
}

const CorrectionRequest = (props: ICorrectionRequestFormModalProps) => {
  const [savedFiles, setSavedFiles] = useState<string[]>([]);
  const [previewFiles, setPreviewFiles] = useState<ICorrectionFileList[]>([]);
  const [deletedFiles, setDeletedFiles] = useState<string[]>([]);

  const { productStore, authStore, correctionControlStore } = useStore();

  const {
    FileUploadService,
    fileUploadState,
    resetFileUploadState,
    uploadedFile,
    addCorrectionRequestState,
    AddCorrectionRequestService,
    getPreviousCorrectionRequestState,
    GetPreviousCorrectionRequestService,
    resetGetPreviousCorrectionRequestState,
    previousRequests,
    DeleteFileService,
    deleteFileState,
    resetDeleteFileState,
    GetCorrectionRequestByIdService,
    getCorrectionRequestByIdState,
  } = correctionControlStore;

  const { GetProductProcessByIdService, productProcessOptions } = productStore;

  const { getUserName } = authStore;

  const initialValues = {};

  useEffect(() => {
    GetProductProcessByIdService(
      Number(getTenantIdFromLocalStorage()),
      props.ProductId
    );
    GetPreviousCorrectionRequestService(
      Number(getTenantIdFromLocalStorage()),
      props.ProductId,
      props.ProcessId
    );
  }, []);

  useEffect(() => {
    if (fileUploadState.success) {
      toast.success(formatMessage('file_upload_success'));
      setSavedFiles((prevFiles) => [...prevFiles, uploadedFile?.FilePath]);
      setPreviewFiles((prevFiles) => [
        ...prevFiles,
        {
          S3FilePath: uploadedFile?.S3FilePath,
          FileName: uploadedFile?.FileName,
          FilePath: uploadedFile?.FilePath,
        },
      ]);
      resetFileUploadState();
    }
  }, [fileUploadState.success]);

  useEffect(() => {
    if (addCorrectionRequestState.success) {
      onModalClosed();
    }
  }, [addCorrectionRequestState.success]);

  useEffect(() => {
    if (getPreviousCorrectionRequestState.success) {
      resetGetPreviousCorrectionRequestState();
    }
  }, [getPreviousCorrectionRequestState.success]);

  useEffect(() => {
    if (deleteFileState.success) {
      resetDeleteFileState();
    }
  }, [deleteFileState.success]);

  const onSubmitForm = ({
    ModificationMessage,
    CorrectionFiles,
    Title,
    ProcessId,
  }: any) => {
    var obj: ICorrectionRequest = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      ProcessId: Number(ProcessId),
      ProductId: props.ProductId,
      ModificationMessage,
      CorrectionFileList: CorrectionFiles,
      Title,
    };
    console.log(obj);
    AddCorrectionRequestService(obj);
  };

  const handleDelete = (index: number) => {
    const deletedFile = previewFiles[index];
    setPreviewFiles((prev) => prev.filter((_, i) => i !== index));
    DeleteFileService(deletedFile.FilePath);
    // setDeletedFiles((prev) => [...prev, ])
    // DeleteProductFileService(Number(getTenantIdFromLocalStorage()), )
  };

  /**
   * This function closes the pop up modal and reset getProcessdetails, addUpdate Process observables (success, inprogress
   * and error).
   */
  const onModalClosed = () => {
    props.modalClosed();
  };
  // console.log('productProcessOptions:', productProcessOptions);
  return (
    <React.Fragment>
      <DefaultModal
        id={Number(props.id)}
        size="xl"
        className="correction-request-modal fancy-modal"
        addHeader="assign_group_code"
        updateHeader="request_correction"
        onModalClosed={onModalClosed}
        isLoading={
          addCorrectionRequestState.inProgress ||
          getPreviousCorrectionRequestState.inProgress ||
          fileUploadState.inProgress ||
          deleteFileState.inProgress
        }
      >
        <CorrectionRequestForm
          id={String(props.id)}
          initialValues={initialValues}
          submitHandler={onSubmitForm}
          onModalClosed={onModalClosed}
          isLoading={addCorrectionRequestState.inProgress || fileUploadState.inProgress}
          allProductProcess={productProcessOptions}
          productName={props.ProductName}
          fileUploadService={FileUploadService}
          fileUploadSuccess={fileUploadState.success}
          previewFiles={previewFiles}
          handleDelete={handleDelete}
          processId={props.ProcessId}
          userName={getUserName}
          previousRequests={previousRequests}
          GetCorrectionRequestByIdService={GetCorrectionRequestByIdService}
        />
      </DefaultModal>
    </React.Fragment>
  );
};

export default observer(CorrectionRequest);
